import { renderElement } from "../../utils/use-render.js";
import { usePopoverContext } from "./context.js";
import { forwardRef, useCallback } from "react";
//#region src/ui/popover/trigger.tsx
/** Button that toggles the popover visibility. Renders a `<button>` element. */
const PopoverTrigger = forwardRef(function PopoverTrigger({ render, className, style, ...elementProps }, forwardedRef) {
	const { core, popover, state, stateAttrMap, popupId } = usePopoverContext();
	const controlledId = state.open ? popupId : void 0;
	const triggerRef = useCallback((el) => {
		popover.setTriggerElement(el);
	}, [popover]);
	const { onFocusIn, onFocusOut, ...restTriggerProps } = popover.triggerProps;
	return renderElement("button", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef, triggerRef],
		props: [
			{
				type: "button",
				...core.getTriggerAttrs(state, controlledId)
			},
			{
				...restTriggerProps,
				onFocus: onFocusIn,
				onBlur: onFocusOut
			},
			elementProps
		]
	});
});
//#endregion
export { PopoverTrigger };

//# sourceMappingURL=trigger.js.map